<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <router-link to="/new-game/multiplayer" class="btn btn--icon btn--white"><i class="material-icons">keyboard_arrow_left</i></router-link>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Find opponent</h1>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <avatar>Enter room code</avatar>

            <div>
                <input type="text" v-on:keyup.enter="checkCode" class="form-control text--center mb--md" v-model="code" placeholder="Room code" />
                <button type="button" class="btn btn--block btn--primary mb--md" @click="checkCode">Connect</button>
            </div>
        </section>

        <navigation></navigation>

        <modal ref="alertModal" type="error" show="false">
            <template v-slot:message>
                Initialization failed: game with code <b>{{ code }}</b> not found!
            </template>

            <template v-slot:buttons>
                <button type="button" @click="closeAlert" class="btn btn--block btn--yellow">Close</button>
            </template>
        </modal>
    </div>
</template>

<script>

    import api from "../../../api/simpleGroupGame";
    import Navigation from "../../partial/Navigation";

    export default {
        components: {Navigation},
        data: function () {
            return {
                code: null,
            }
        },

        methods: {
            checkCode() {
                if (! this.code) {
                    return;
                }

                api.findGame(this.code).then(() => {
                    this.$router.push('/g/' + this.code)
                }).catch( (error) => {
                    this.$refs.alertModal.open()
                })
            },

            closeAlert() {
                this.$refs.alertModal.close()
            }
        }
    }
</script>
